import { RootShape } from '../../../element-editor/shape/shapes/general/root/root-shape';
import {
  setFileDescriptorItem,
  setSelectedStoryBoardItem,
} from '../../../element-editor/store/editor.actions';
import { Coords } from '../../../elements/resource/types/shape.type';
import { _screenX, _screenY } from '../canvas.service';
import { StoryBoardItem, StoryBoardItemDescriptor } from './story-board-item';

export interface StoryBoardDescriptor {
  items: StoryBoardItemDescriptor[];
}

export const STORYBOARD_GAP = 40;
export class StoryBoardController {
  // -- // -- // -- // -- // -- //
  items: StoryBoardItem[];
  get cs() {
    return this.rootShape.cs;
  }
  get store() {
    return this.rootShape.store;
  }
  constructor(
    public readonly rootShape: RootShape,
    public descriptor: StoryBoardDescriptor,
  ) {
    this.descriptor = descriptor;
    this.items?.map(item => item.delete());

    this.items = descriptor.items.map(
      (item, i) => new StoryBoardItem(this, item, i),
    );
    this.items.map((item, index) => {
      // -- // -- // -- //
      item.prev = this.items[index - 1];
      item.next = this.items[index + 1];
    });
  }

  save() {
    console.log('set-file-descriptor-item', {
      items: this.items.map(item => item.descriptor),
    } as StoryBoardDescriptor);
    this.store.dispatch(
      setFileDescriptorItem({
        key: 'storyBoard',
        value: {
          items: this.items.map(item => item.descriptor),
        } as StoryBoardDescriptor,
      }),
    );
  }

  delete() {
    this.items.map(item => item.delete()); // -- //
  }

  getOffsetByPosition(x: number, y: number): [Coords, number] {

    // with the slice we omit the first item (as it is at 0,0 there's no offset)
    for (const item of this.items) {
      const offset = item.doesContainPoint(x, y);
      if (offset) {
        return [offset as Coords, item.id];
      }
    }
  }

  addNext(item: StoryBoardItem) {
    let id: number;
    if (item.next) {
      id = (item.id + item.next.id) / 2;
    } else if (item.id % 1 == 0) {
      id = item.id % 1 == 0 ? item.id + 1 : Math.ceil(item.id);
    }

    const newItem = new StoryBoardItem(
      this,
      {
        id,
        notes: [],
      },
      item.index + 1,
    );

    this.items[newItem.index] = newItem;

    if (item.next) {
      item.next.shiftRight();
      const buffer = item.next;
      newItem.next = buffer;
      buffer.prev = newItem;
    }

    item.next = newItem;
    newItem.prev = item;

    // -- // -- //
    this.save();
  }

  getOffset(index: number) {
    const [w, h] = [_screenX, _screenY];
    return [index * (w + STORYBOARD_GAP), 0, w, h];
  }

  checkClick(x: number, y: number) {
    const { x: xa, y: ya } = this.cs.getAbsoluteCoords(x, y);
    const found = this.getOffsetByPosition(xa, ya);
    if (found) {
      const [offset, id] = found;
      this.cs.fitCanvas(-offset[0]);
      this.store.dispatch(setSelectedStoryBoardItem({ id }));
    }
  }
}
